import { useNavigate } from "react-router-dom";
import { CustomButton2, CustomView } from "../../../../panel/components";
import Lottie from "react-lottie-player";
import anHome from "../../../../assets/animations/homepage-lootie.json";

const Banner = () => {
  return (
    <CustomView.Row className="banner">
      <CustomView.Column medium={5} className="download-button">
        <h3>تفکیک , پلتفرم خرید پسماند قابل بازیافت از درب منزل</h3>
        <a href="https://cafebazaar.ir/app/com.tafkiktsapp">
          <CustomButton2
            onClick={() => {}}
            leftIcon="fa fa-download fa-2x"
            title={"دانلود اپلیکیشن اندروید"}
          />
        </a>
      </CustomView.Column>
      <CustomView.Column medium={7}>
        <div className="right-side">
          <Lottie
            loop
            animationData={anHome}
            play
            style={{ width: "100%", height: "90%" }}
          />
        </div>
      </CustomView.Column>
    </CustomView.Row>
  );
};

export default Banner;
